/** @file screenToTile: a screen delta expressed along a tile's two screen axes (tile px per axis). */

/**
 * `[a, b]` with `a u + b v = d`: `u`, `v` are the tile's screen axes per tile pixel (target px), `d` a screen delta
 * (target px). `[0, 0]` when the axes are degenerate (an edge-on quad).
 */
export function screenToTile(u: readonly [number, number], v: readonly [number, number], d: readonly [number, number]): [number, number] {
  const det = u[0] * v[1] - u[1] * v[0];
  if (Math.abs(det) < 1e-9) return [0, 0];
  return [(d[0] * v[1] - d[1] * v[0]) / det, (u[0] * d[1] - u[1] * d[0]) / det];
}
